import React, { useState, useEffect } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [activePhrase, setActivePhrase] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePhrase(prev => prev === 0 ? 1 : 0);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  // Utilisation d'un array d'objets pour plus de flexibilité
  const phrasesData = [
    {
      id: 0,
      text: "Accélérée par l'IA pour mieux qualifier vos rendez-vous"
    },
    {
      id: 1,
      text: "Soutenue par un accompagnement humain pour mieux les convertir"
    }
  ];

  return (
    <section className="hero">
      <div className="hero-light hero-light-1"></div>
      <div className="hero-light hero-light-2"></div>
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            La première Suite de<br />prospection Commerciale
          </h1>
          <div className="animated-phrase-wrapper">
            {phrasesData.map((phrase) => (
              <h2 
                key={phrase.id}
                className="animated-phrase"
                style={{ 
                  opacity: activePhrase === phrase.id ? 1 : 0,
                  position: 'absolute',
                  visibility: activePhrase === phrase.id ? 'visible' : 'hidden'
                }}
              >
                {phrase.text}
              </h2>
            ))}
          </div>
          <p className="hero-subtitle">
            Multipliez vos conversions B2B grâce à une approche scientifique de la prospection, 
            portée par un collectif d'experts qui déploie pour vous des campagnes multi-leviers optimisées.
          </p>
          <div className="hero-button-container">
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer" className="hero-button">TESTEZ VOTRE ÉLIGIBILITÉ</a>
            <Link to="/suite" className="hero-button hero-button-secondary">DÉCOUVRIR NOTRE SUITE</Link>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L10 10L19 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero; 